import type { Entry } from 'contentful';

import { LinkSectionData, MegaNavData } from '../models';
import { isTypeLinkSection, TypeMegaNavSkeleton } from '../models/cms';

import { transformLinkSection } from '.';

export const transformMegaNav = (entry: Entry<TypeMegaNavSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): MegaNavData => {
  const sections = entry.fields.sections.reduce((acc, section) => {
    if (!section) {
      return acc;
    }

    if (isTypeLinkSection(section)) {
      return [...acc, transformLinkSection(section)];
    }

    // don't want to throw here in-case any new types are added,
    // instead we'll just ignore it and carry on

    return acc;
  }, [] as Array<LinkSectionData>);

  if (sections.length < 1) {
    throw new Error(`Expected at least 1 section in mega nav item: ${entry.sys.id}`);
  }

  return {
    footerText: entry.fields.footerText,
    label: entry.fields.label,
    link: { href: entry.fields.bottomLinkHref, text: entry.fields.bottomLinkText },
    sections,
  };
};
